import { useQuery } from '@apollo/client'
import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { VALUE_PROP_LIST } from 'queries'
import { CMSValueProp } from 'types'

export const SharePageValueProps = () => {
  const { colors, mediaQueries } = useTheme()
  const { data, loading, error } = useQuery(VALUE_PROP_LIST, {
    variables: { id: '19fZ0owdiv6gtY4XkcjWHf' },
  })

  if (loading || !!error) return null

  const valuePropsList = data?.valuePropList
  const valueProps = valuePropsList?.listCollection?.items || []

  return (
    <FlexBox flexDirection="column" alignItems="center" gap="16px">
      <Text
        className={css`
          max-width: 180px;
          ${mediaQueries.mobileL} {
            max-width: 280px;
          }
        `}
        tag="h2"
        type="header"
        sizing={{ base: 'S', mobileL: 'M' }}
        align="center"
      >
        {valuePropsList?.title}
      </Text>
      <FlexBox flexDirection="column" alignItems="stretch" gap="16px">
        {valueProps.map((item: CMSValueProp, i: number) => (
          <FlexBox
            key={i}
            className={css`
              height: 100%;
              background-color: ${colors.uiPearlUltraLight};
              border-radius: 16px;
              overflow: hidden;
              ${mediaQueries.mobileL} {
                background-color: ${colors.uiPearlExtraLight};
              }
            `}
            alignItems="stretch"
          >
            <img
              className={css`
                display: block;
                width: 154px;
                flex-shrink: 0;
                object-fit: contain;
                object-position: bottom;
              `}
              src={item.image.url}
              alt={item.image.title}
            />
            <FlexBox
              className={css`
                padding: 0 16px;
                width: 100%;
                height: 180px;
                background-color: ${colors.uiPearlExtraLight};
                text-align: left;
                flex-direction: column;
                justify-content: center;
                ${mediaQueries.mobileL} {
                  padding: 0 24px;
                  background-color: ${colors.uiWhite};
                }
              `}
            >
              <Text
                className={css`
                  margin-bottom: 8px;
                `}
                tag="p"
                text={item.title}
                type="subhead"
                sizing={{ base: 'XS', mobileL: 'S' }}
                color={colors.uiGraphite}
              />
              <Text
                text={item.subtitle}
                type="body"
                sizing={{ base: 'S', mobileXS: 'M' }}
                color={colors.uiGraphiteLight}
              />
            </FlexBox>
          </FlexBox>
        ))}
      </FlexBox>
    </FlexBox>
  )
}
